'use client';

import { GoogleAnalytics } from '@next/third-parties/google';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

export default function GoogleAnalyticsWrapper() {
  const [isCookieConsentAccepted, setIsCookieConsentAccepted] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const consentCookie = Cookies.get('arcanis-capital-cookies-consent');
      setIsCookieConsentAccepted(consentCookie === 'true');
    };

    checkConsent();
    const interval = setInterval(checkConsent, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!isCookieConsentAccepted) {
    return null;
  }

  return <GoogleAnalytics gaId="G-50HVG99XV3" />;
}
